var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, getTestId, isValidObject, LILAC_500, StateConfigContext, tokens, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { View } from 'react-native';
import { PriceDetailWidget } from '../price-detail-widget';
import { getButtonWidgetStyles, getWrapperStyles } from './ButtonWidgetStyles';
var Wrapper = _ref => {
  var showBorderTop = _ref.showBorderTop,
    showBorderTopAsFullWidth = _ref.showBorderTopAsFullWidth,
    children = _ref.children;
  var _borderTop = showBorderTop && showBorderTopAsFullWidth;
  var wrapperStyles = getWrapperStyles();
  return _borderTop ? _jsx(View, Object.assign({
    style: wrapperStyles.wrapper
  }, {
    children: children
  })) : _jsx(_Fragment, {
    children: children
  });
};
export var ButtonWidgetComponent = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  var id = props.id,
    _props$leftCta = props.leftCta,
    leftCta = _props$leftCta === void 0 ? {} : _props$leftCta,
    _props$rightCta = props.rightCta,
    rightCta = _props$rightCta === void 0 ? {} : _props$rightCta,
    onUserAction = props.onUserAction,
    onLeftCtaPress = props.onLeftCtaPress,
    onRightCtaPress = props.onRightCtaPress,
    buttonVersionPlatformSpecific = props.buttonVersionPlatformSpecific,
    buttonSizePlatformSpecific = props.buttonSizePlatformSpecific,
    style = props.style,
    showBorderTop = props.showBorderTop,
    showBorderTopAsFullWidth = props.showBorderTopAsFullWidth,
    _props$showDividerBet = props.showDividerBetweenButtons,
    showDividerBetweenButtons = _props$showDividerBet === void 0 ? false : _props$showDividerBet,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ButtonWidgetContainer' : _props$testID,
    restProps = __rest(props, ["id", "leftCta", "rightCta", "onUserAction", "onLeftCtaPress", "onRightCtaPress", "buttonVersionPlatformSpecific", "buttonSizePlatformSpecific", "style", "showBorderTop", "showBorderTopAsFullWidth", "showDividerBetweenButtons", "testID"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var rightCtaVersion = isSmallScreen ? (_a = buttonVersionPlatformSpecific === null || buttonVersionPlatformSpecific === void 0 ? void 0 : buttonVersionPlatformSpecific.rightCta) === null || _a === void 0 ? void 0 : _a.mobile : (_b = buttonVersionPlatformSpecific === null || buttonVersionPlatformSpecific === void 0 ? void 0 : buttonVersionPlatformSpecific.rightCta) === null || _b === void 0 ? void 0 : _b.desktop;
  var leftCtaVersion = isSmallScreen ? (_c = buttonVersionPlatformSpecific === null || buttonVersionPlatformSpecific === void 0 ? void 0 : buttonVersionPlatformSpecific.leftCta) === null || _c === void 0 ? void 0 : _c.mobile : (_d = buttonVersionPlatformSpecific === null || buttonVersionPlatformSpecific === void 0 ? void 0 : buttonVersionPlatformSpecific.leftCta) === null || _d === void 0 ? void 0 : _d.desktop;
  var rightCtaSize = isSmallScreen ? (_e = buttonSizePlatformSpecific === null || buttonSizePlatformSpecific === void 0 ? void 0 : buttonSizePlatformSpecific.rightCta) === null || _e === void 0 ? void 0 : _e.mobile : (_f = buttonSizePlatformSpecific === null || buttonSizePlatformSpecific === void 0 ? void 0 : buttonSizePlatformSpecific.rightCta) === null || _f === void 0 ? void 0 : _f.desktop;
  var leftCtaSize = isSmallScreen ? (_g = buttonSizePlatformSpecific === null || buttonSizePlatformSpecific === void 0 ? void 0 : buttonSizePlatformSpecific.leftCta) === null || _g === void 0 ? void 0 : _g.mobile : (_h = buttonSizePlatformSpecific === null || buttonSizePlatformSpecific === void 0 ? void 0 : buttonSizePlatformSpecific.leftCta) === null || _h === void 0 ? void 0 : _h.desktop;
  var leftCtaProps = Object.assign(Object.assign({}, leftCta), {
    version: (_j = buttonVersionPlatformSpecific ? leftCtaVersion : leftCta === null || leftCta === void 0 ? void 0 : leftCta.version) !== null && _j !== void 0 ? _j : 'variable-width',
    size: (_k = buttonSizePlatformSpecific ? leftCtaSize : leftCta === null || leftCta === void 0 ? void 0 : leftCta.size) !== null && _k !== void 0 ? _k : 'sm'
  });
  var rightCtaProps = Object.assign({
    version: (_l = buttonVersionPlatformSpecific ? rightCtaVersion : rightCta === null || rightCta === void 0 ? void 0 : rightCta.version) !== null && _l !== void 0 ? _l : 'variable-width',
    size: (_m = buttonSizePlatformSpecific ? rightCtaSize : rightCta === null || rightCta === void 0 ? void 0 : rightCta.size) !== null && _m !== void 0 ? _m : 'sm'
  }, rightCta);
  var buttonWidgetStyles = getButtonWidgetStyles(Object.assign(Object.assign({}, props), {
    leftCta: leftCtaProps,
    rightCta: rightCtaProps
  }));
  var container = buttonWidgetStyles.container,
    button = buttonWidgetStyles.button,
    rightButton = buttonWidgetStyles.rightButton,
    leftButton = buttonWidgetStyles.leftButton,
    priceBreakupContainer = buttonWidgetStyles.priceBreakupContainer,
    dividerStyle = buttonWidgetStyles.dividerStyle;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var onPressLeftCta = event => {
    var _a;
    (_a = leftCta === null || leftCta === void 0 ? void 0 : leftCta.onPress) === null || _a === void 0 ? void 0 : _a.call(leftCta, event);
    isValidObject(onLeftCtaPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onLeftCtaPress), Object.assign({
      leftCta
    }, leftCta)));
  };
  var onPressRightCta = event => {
    var _a;
    (_a = rightCta === null || rightCta === void 0 ? void 0 : rightCta.onPress) === null || _a === void 0 ? void 0 : _a.call(rightCta, event);
    isValidObject(onRightCtaPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onRightCtaPress), Object.assign({
      rightCta
    }, rightCta)));
  };
  var leftPriceBreakup = leftCtaProps.priceBreakup,
    leftCtaRestProps = __rest(leftCtaProps, ["priceBreakup"]);
  var rightPriceBreakup = rightCtaProps.priceBreakup,
    rightCtaRestProps = __rest(rightCtaProps, ["priceBreakup"]);
  var showLeftButton = ((_o = leftCtaRestProps === null || leftCtaRestProps === void 0 ? void 0 : leftCtaRestProps.title) === null || _o === void 0 ? void 0 : _o.length) > 0;
  var showRightButton = ((_p = rightCtaRestProps === null || rightCtaRestProps === void 0 ? void 0 : rightCtaRestProps.title) === null || _p === void 0 ? void 0 : _p.length) > 0;
  var showButtonWidget = showLeftButton || showRightButton;
  var isDividerVisible = showLeftButton && showRightButton && showDividerBetweenButtons;
  var marginRightStyle = isDividerVisible ? {
    marginRight: tokens.spacing.SPACING_12
  } : {};
  var marginLeftStyle = isDividerVisible ? {
    marginLeft: tokens.spacing.SPACING_12
  } : {};
  restProps === null || restProps === void 0 ? true : delete restProps.direction;
  return _jsx(Wrapper, Object.assign({
    showBorderTop: showBorderTop,
    showBorderTopAsFullWidth: showBorderTopAsFullWidth
  }, {
    children: !!showButtonWidget && _jsxs(View, Object.assign({
      style: [container, style]
    }, getTestId(testID), restProps, {
      children: [(isValidObject(leftPriceBreakup) || showLeftButton) && _jsxs(View, Object.assign({
        style: [button, leftButton, marginRightStyle]
      }, {
        children: [isValidObject(leftPriceBreakup) && _jsx(PriceDetailWidget, Object.assign({
          style: !!leftCta.title && priceBreakupContainer
        }, leftPriceBreakup, {
          onUserAction: onUserAction
        }, getTestId(testID, 'priceDetail'))), showLeftButton && _jsx(Button, Object.assign({}, leftCtaRestProps, {
          onPress: onPressLeftCta,
          theme: theme
        }, getTestId(testID, 'leftCta')))]
      })), isDividerVisible && _jsx(Divider, {
        isVertical: true,
        height: 1,
        theme: theme,
        color: LILAC_500,
        style: dividerStyle
      }), (isValidObject(rightCta) || showRightButton) && _jsxs(View, Object.assign({
        style: [button, isValidObject(leftCtaRestProps) && rightButton, marginLeftStyle]
      }, {
        children: [isValidObject(rightPriceBreakup) && _jsx(PriceDetailWidget, Object.assign({
          style: !!(rightCta === null || rightCta === void 0 ? void 0 : rightCta.title) && priceBreakupContainer
        }, rightPriceBreakup, {
          onUserAction: onUserAction
        })), showRightButton && _jsx(Button, Object.assign({}, rightCtaRestProps, {
          onPress: onPressRightCta,
          theme: theme
        }, getTestId(testID, 'rightCta')))]
      }))]
    }))
  }));
};
ButtonWidgetComponent.genericRendererKey = 'AirButtonWidget';